<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="includeExChangeAgent ? $t('Message.SendAgentByCaseNumber') : $t('Message.SendPortAgentByNumber')"
    width="600px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 100%;min-height: 350px;"
    />
    <span slot="footer">
      <el-button v-show="selectedRow && (!selectedRow.sendTime || selectedRow.allowAgainSend)" no="SendEmail" type="primary" @click="onSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as jobContainerNoApi from '@/api/booking/jobContainerNo'

export default {
  name: 'JobContainerNoSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    containerNoList: { type: Array, required: true },
    includeExChangeAgent: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        onCellFocused: (event) => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      rowData: [],
      selectedNode: null
    }
  },
  computed: {
    columnDefs() {
      const result = [{
        headerName: this.$t('queryJob.containerNo'),
        field: 'containerNo',
        width: this.includeExChangeAgent ? 150 : 350
      }]
      if (this.includeExChangeAgent) {
        result.push({
          headerName: this.$t('Message.SetOrderAgency'),
          field: 'exchangeAgent',
          width: 200,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        })
      }
      result.push({
        headerName: this.$t('Message.LastSentTime'),
        field: 'sendTime',
        width: 200
      })
      return result
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  methods: {
    async init() {
      const res = await jobContainerNoApi.getList({ jobUuid: this.jobUuid })
      const itemMap = new Map()
      for (const item of res.data) {
        if (item.exchangeAgent) {
          itemMap.set(`${item.containerNo}-${item.exchangeAgent}`, item)
        } else {
          itemMap.set(item.containerNo, item)
        }
      }
      for (const containerNo of this.containerNoList) {
        if (this.includeExChangeAgent) {
          // 排除exchangeAgent为空的记录
          if (!containerNo.exchangeAgent) {
            continue
          }
          if (itemMap.has(`${containerNo.containerNo}-${containerNo.exchangeAgent}`)) {
            this.rowData.push({ ...containerNo, ...itemMap.get(`${containerNo.containerNo}-${containerNo.exchangeAgent}`) })
          } else {
            this.rowData.push({ ...containerNo, uuid: '', sendTime: '', allowAgainSend: false })
          }
        } else {
          // 只保留exchangeAgent为空的记录
          if (containerNo.exchangeAgent) {
            continue
          }
          if (itemMap.has(containerNo.containerNo)) {
            this.rowData.push({ ...containerNo, ...itemMap.get(containerNo.containerNo) })
          } else {
            this.rowData.push({ ...containerNo, uuid: '', sendTime: '', allowAgainSend: false })
          }
        }
      }
    },
    onSendEmail() {
      this.innerVisible = false
      this.$emit('callback', this.selectedRow)
    }
  }
}
</script>
